import React from 'react';
import { Redirect } from 'react-router-dom'

export default class LoginController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { success: false, inFlight: false, username: null, password: null };
  }

  login() {
    this.setState({ inFlight: true });
    fetch('/api/login', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({username: this.state.username, password: this.state.password})
    }).then(res => {
      const success = res.status === 200;
      this.setState({ inFlight: false, success });
    });
  }

  render() {
    if (this.state.inFlight) {
      return <div>Authenticating...</div>;
    }
    if (this.state.success) {
      return <Redirect to='/' />;
    }

    return (<div>
      <input type="text"
        onChange={(e) => this.setState({username: e.target.value})}
        placeholder="username or email" />
      <input type="password"
        onChange={(e) => this.setState({password: e.target.value})}
        placeholder="text" />

      <button onClick={(e) => this.login()}>submit</button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/LoginController.js